import styled from "styled-components";

export const StyledFlowV2Wrapper = styled.div<{ scale: number }>`
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 90px);
  padding: 16px;
  overflow: hidden;

  .scalable-wrapper {
    transform: ${(props) => `scale(${props?.scale || 1})`};
    transform-origin: top left;
    width: 1380px;
    min-height: 640px;
    box-sizing: border-box;
  }

  /* ─── Top Header / Breadcrumb ─── */
  .v2-header {
    display: flex;
    align-items: center;
    column-gap: 8px;
    margin-bottom: 8px;

    .breadcrumb-label {
      font-size: 12px;
      color: #334155;
      font-weight: 500;
    }

    .breadcrumb-tag {
      background: #f1f5f9;
      color: #1e3a8a;
      padding: 3px 14px;
      border-radius: 2px;
      font-size: 12px;
      font-weight: 600;
      border: 1px solid #94a3b8;
      border-bottom: 2px solid #1e3a8a;
    }
  }

  /* ─── Main Flowchart Layout ─── */
  .v2-flow-container {
    display: flex;
    flex-direction: column;
    row-gap: 0;
    width: 100%;
  }

  /* ─── Top Level Banners & Note Button (Topmost Layer) ─── */
  .v2-top-banner-row {
    display: flex;
    align-items: center;
    height: 32px;
    width: 100%;

    .top-sidebar-btn {
      width: 84px;
      min-width: 84px;
      display: flex;
      align-items: center;
      margin-top: 90px;
      z-index: 100;
    }

    .btn-show-note {
      border-radius: 4px;
      background-color: #1a365d;
      color: #ffffff;
      border: 1px solid #0f172a;
      padding: 4px 6px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 600;
      width: 84px;
      height: 32px;
      text-align: center;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: #2c5282;
      }

      &.active {
        background-color: #808080;
      }
    }

    .top-banners-wrapper {
      flex: 1;
      display: flex;
      column-gap: 16px;
      height: 32px;

      .banner-left {
        width: 800px;
        background-color: #424e61;
        color: #ffffff;
        font-size: 12px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 0.5px;
      }

      .banner-right {
        width: 480px;
        background-color: #424e61;
        color: #ffffff;
        font-size: 12px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 0.5px;
      }
    }
  }

  /* ─── Main Phase Area (Bizシート 作成・利用) ─── */
  .v2-main-phase-row {
    display: flex;
    column-gap: 0;
    width: 100%;
  }

  /* ─── Permission Phase Area (権限設定) ─── */
  .v2-perm-phase-row {
    display: flex;
    column-gap: 0;
    width: 100%;
    margin-top: 14px;
  }

  /* ─── Sidebar Block ─── */
  .v2-sidebar-block {
    width: 84px;
    min-width: 84px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.5;
    background-color: #424e61;
    padding: 12px 6px;
    box-sizing: border-box;

    &.phase-main {
      height: 370px;
      margin-top: 60px;
    }

    &.phase-permission {
      height: 96px;
    }
  }

  /* ─── Main Content Canvas (Two gray columns #edf2f7) ─── */
  .v2-main-content-canvas {
    flex: 1;
    position: relative;
    width: 1296px;
    height: 420px;
  }

  /* ─── Column Background Panels ─── */
  .col-panel-body-bg {
    position: absolute;
    top: 0;
    height: 370px;
    background-color: #edf2f7;

    &.left-panel {
      left: 0;
      width: 790px;
      margin-top: 60px;
      margin-left: 10px;
    }

    &.right-panel {
      margin-top: 60px;
      left: 816px;
      width: 480px;
    }
  }

  /* ─── Permission Content Canvas (With gray background #edf2f7) ─── */
  .v2-perm-content-canvas {
    flex: 1;
    position: relative;
    width: 1296px;
    height: 96px;
    background-color: #edf2f7;
  }

  /* ─── Interactive Elements Layer ─── */
  .elements-layer-full {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 4;
    pointer-events: auto;
  }

  /* ─── Node Boxes ─── */
  .btn-capsule {
    background-color: #ffffff;
    color: #1e3a83;
    border: 1px solid #1e293b;
    border-radius: 9999px;
    padding: 4px 14px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
      background-color: #f8fafc;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }

  .node-box {
    background-color: #ffffff;
    border: 1px solid #1e293b;
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 600;
    color: #1e3a83;
    text-align: center;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    &.border-navy {
      border: 1px solid #1e3a8a;
      color: #1e3a8a;
    }
  }

  /* ─── Flow Card ─── */
  .flow-card {
    background-color: #ffffff;
    border: 1px solid #2d3e5e;
    padding: 8px 10px;
    box-sizing: border-box;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .card-label {
      font-size: 12px;
      font-weight: 600;
      color: #1e3a83;
      margin-bottom: 6px;
      text-align: center;
      white-space: nowrap;
    }

    .card-action-btn {
      width: 100%;
      height: 28px;
      background-color: #1a365d;
      color: #ffffff;
      font-size: 12px;
      font-weight: 600;
      border-radius: 4px;
      border: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      column-gap: 6px;
      cursor: pointer;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
      transition: background-color 0.2s ease;
      padding: 0.5rem;

      &:hover {
        background-color: #2c5282;
      }

      &.disabled {
        background-color: #718096;
        opacity: 0.65;
        cursor: not-allowed;

        &:hover {
          background-color: #718096;
        }
      }

      .ext-link-icon {
        font-size: 12px;
        stroke-width: 2.2;
      }
    }
  }

  /* ─── Branch Text Label ─── */
  .branch-label {
    font-size: 12px;
    font-weight: 600;
    color: #1e3a83;
    background-color: #edf2f7;
    padding: 0 4px;
    white-space: nowrap;
    user-select: none;
  }
`;

export const StyledCalloutBubble = styled.div<{
  placement?: "bottom" | "right" | "top" | "left";
}>`
  position: absolute;
  background-color: #2d3748;
  color: #ffffff;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.5;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  z-index: 100;
  pointer-events: none;

  p {
    margin: 0;
    font-size: 12px;
    line-height: 1.4;
    color: #ffffff;
  }

  ${(props) =>
    props.placement === "bottom" &&
    `
    &::before {
      content: "";
      position: absolute;
      top: -5px;
      left: 48%;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid #2d3748;
    }
  `}

  ${(props) =>
    props.placement === "right" &&
    `
    &::before {
      content: "";
      position: absolute;
      left: -5px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-right: 5px solid #2d3748;
    }
  `}

  ${(props) =>
    props.placement === "top" &&
    `
    &::before {
      content: "";
      position: absolute;
      bottom: -5px;
      left: 48%;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid #2d3748;
    }
  `}
`;
export const StyledHoverTooltip = styled.div<{
  bg?: string;
  borderRadius?: number;
}>`
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;

  .custom-tooltip-content {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    bottom: calc(100% + 5px);
    left: 50%;
    transform: translateX(-50%);
    background-color: ${(props) => props.bg || "#2d3748"};
    color: #ffffff;
    border-radius: ${(props) =>
      props.borderRadius !== undefined ? props.borderRadius : 4}px;
    padding: 6px 10px;
    font-size: 12px;
    line-height: 1.5;
    white-space: nowrap;
    z-index: 10;
    pointer-events: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    transition: opacity 0.2s;

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-width: 5px;
      border-style: solid;
      border-color: ${(props) => props.bg || "#2d3748"} transparent transparent
        transparent;
    }
  }

  &:hover .custom-tooltip-content {
    visibility: visible;
    opacity: 1;
  }
`;
